import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=f416e146&scoped=true"
var script = {}
import style0 from "./page-title.vue?vue&type=style&index=0&id=f416e146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f416e146",
  null
  
)

export default component.exports